<ng-container [ngSwitch]="displayMode">
    <div class="btn-group btn-group-toggle" *ngSwitchCase="'button'">
        <label *ngFor="let day of daysInOrder; index as i" [id]="(pageName + '-dowSelector-' + day) | cleanId" class="btn btn-secondary" [class.btn-sm]="size === 'small'" [class.btn-lg]="size === 'large'" ngbButtonLabel>
            <input type="checkbox" ngbButton [(ngModel)]="checkedDays[day]" (ngModelChange)="onDaysChanged()" [value]="day"> {{ daysLocalizedInOrder[i] }}
        </label>
    </div>
    <div class="d-flex justify-content-between" *ngSwitchCase="'checkbox'">
        <ng-container *ngIf="useCxOne">
            <sol-checkbox *ngFor="let day of daysInOrder"
                [(ngModel)]="checkedDays[day]"
                (ngModelChange)="onDaysChanged()"
                [checkboxId]="(pageName + '-dowSelector-' + day) | cleanId"
                 [value]="day"
            >{{day}}</sol-checkbox>
        </ng-container>
        <ng-container *ngIf="!useCxOne">
            <div class="form-check form-check-inline" *ngFor="let day of daysInOrder; index as i">
                <input class="form-check-input" type="checkbox" [attr.id]="(pageName + '-dowSelector-' + day) | cleanId" [value]="day" [(ngModel)]="checkedDays[day]" (ngModelChange)="onDaysChanged()">
                <label class="form-check-label" [attr.for]="(pageName + '-dowSelector-' + day) | cleanId">{{ daysLocalizedInOrder[i] }}</label>
            </div>
        </ng-container>
    </div>
</ng-container>
